import { render } from "./innovaDetail.vue?vue&type=template&id=32378eba&scoped=true"
import script from "./innovaDetail.vue?vue&type=script&lang=js"
export * from "./innovaDetail.vue?vue&type=script&lang=js"

import "./innovaDetail.vue?vue&type=style&index=0&id=32378eba&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32378eba"]])

export default __exports__